module.exports = __webpack_public_path__ + "img/showcase-facebook-en-ca.461c3b46.jpg";